<template>
  <div class="home">
    <!-----home-banner-area ------>
    <section class="home-banner-area p-top-135">
      <carousel :per-page="1" :autoplay="true" :loop="true">
        <slide>
          <img
            src="@/assets/images/slider1.jpg"
            width="100%"
            class="img-fluid"
            alt=""
          />
        </slide>
        <slide>
          <img
            src="@/assets/images/slider2.jpg"
            width="100%"
            class="img-fluid"
            alt=""
          />
        </slide>
      </carousel>
    </section>
    <!------ end home-banner-area ----->
    <!-- about-us-sec -->
    <section class="about-sec mrg-top-70">
      <div class="container">
        <!--  -->
        <div class="row">
          <div class="col-lg-6 col-md-12 col-sm-12">
            <div class="area__subtitle">ABOUT US</div>
            <div class="about-us-card">
              <div class="about-us-body">
                <p>
                  BHIMA RIDDHI INFOTAINMENT PVT. LTD. (BRIPL), a Joint Venture
                  (JV) Company incorporated under the Companies Act, 1956 is
                  carrying on business of operating Cable Television Networks in
                  Kolhapur, Ichhakaranji, Satara and Sangli District other
                  cities under the brand name “Bhima”(BRI) for which the Company
                  has the requisite permission and license from the concerned
                  authorities and has registered itself with Head Post Office,
                  Kolhapur.
                </p>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="about-us-img">
              <img src="@/assets/images/map.svg" width="100%" alt="" style="width: 70%;" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- MANAGEMENT TEAM -->
    <section class="management-team-sec mrg-top-70">
      <div class="container">
        <div class="title">
          <div class="area__subtitle">MANAGEMENT TEAM</div>
        </div>
        <!-- start signle card -->
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 pl-3">
            <div class="management-team-body">
              <p>
                The promoters Mr. Dhananjay Mahadik, Mr. Harish Gulabani, Mr.
                Nagesh Chabria, Mr. Rajkumar Balani and other Promoter
                Shareholders of BRIPL are the eminent businessmen and their
                business skills and management and administration capabilities
                have made the venture successful. Their desire to set the
                company on pinnacle persuaded them to form a joint Venture with
                INDUSIND MEDIA & COMMUNICATIONS LTD. (IMCL) of Mumbai. The IMCL,
                a Hinduja Venture Company is pioneer and leading Multi System
                Cable and Broadband Operator in India with extensive intra-city
                fiber networks. It is engaged as Multi System Operator in the
                business of Cable TV to direct subscribers as well as to
                operators and franchisee cable operators.
              </p>
            </div>
          </div>
          <!-- start signle card -->
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="management-team-img">
              <div class="row heading">
                <div class="col-md-6 col-md-offset-3">
                  <!-- <h2 class="text-center bottom-line">Meet Our Team</h2>
                <p class="subheading text-center">Creative Nerds</p> -->
                </div>
              </div>

              <div class="row team-row">
                <div class="col-md-3 col-sm-6 team-wrap">
                  <div class="team-member text-center">
                    <div class="team-img">
<!--                       <img
                        src="../assets/images/avatar.webp"
                        alt=""
                      /> -->
                      <div class="overlay">
                        <div class="team-details text-center">
                          <p>
                            Mr. Dhananjay Mahadik
                          </p>
                          <div class="socials mt-20">
                            <a href="#"><i class="fa fa-facebook"></i></a>
                            <a href="#"><i class="fa fa-twitter"></i></a>
                            <a href="#"><i class="fa fa-google-plus"></i></a>
                            <a href="#"><i class="fa fa-envelope"></i></a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h3 class="team-title">Mr. Dhananjay Mahadik</h3>
                    <!-- <span>Designer</span> -->
                  </div>
                </div>
                <!-- end team member -->

                <div class="col-md-3 col-sm-6 team-wrap">
                  <div class="team-member text-center">
                    <div class="team-img">
<!--                       <img
                        src="../assets/images/avatar.webp"
                        alt=""
                      /> -->
                      <div class="overlay">
                        <div class="team-details text-center">
                          <p>
                            Mr. Harish Gulabani
                          </p>
                          <div class="socials mt-20">
                            <a href="#"><i class="fa fa-facebook"></i></a>
                            <a href="#"><i class="fa fa-twitter"></i></a>
                            <a href="#"><i class="fa fa-google-plus"></i></a>
                            <a href="#"><i class="fa fa-envelope"></i></a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h3 class="team-title">Mr. Harish Gulabani</h3>
                    <!-- <span>Photographer</span> -->
                  </div>
                </div>
                <!-- end team member -->

                <div class="col-md-3 col-sm-6 team-wrap">
                  <div class="team-member last text-center">
                    <div class="team-img">
    <!--                   <img
                        src="../assets/images/avatar.webp"
                        alt=""
                      /> -->
                      <div class="overlay">
                        <div class="team-details text-center">
                          <p>
                            Mr. Nagesh Chabria
                          </p>
                          <div class="socials mt-20">
                            <a href="#"><i class="fa fa-facebook"></i></a>
                            <a href="#"><i class="fa fa-twitter"></i></a>
                            <a href="#"><i class="fa fa-google-plus"></i></a>
                            <a href="#"><i class="fa fa-envelope"></i></a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h3 class="team-title">Mr. Nagesh Chabria</h3>
                    <!-- <span>Designer</span> -->
                  </div>
                </div>
                <!-- end team member -->
                <div class="col-md-3 col-sm-6 team-wrap">
                  <div class="team-member last text-center">
                    <div class="team-img">
 <!--                      <img
                        src="../assets/images/avatar.webp"
                        alt=""
                      /> -->
                      <div class="overlay">
                        <div class="team-details text-center">
                          <p>
                            Mr. Rajkumar Balani
                          </p>
                          <div class="socials mt-20">
                            <a href="#"><i class="fa fa-facebook"></i></a>
                            <a href="#"><i class="fa fa-twitter"></i></a>
                            <a href="#"><i class="fa fa-google-plus"></i></a>
                            <a href="#"><i class="fa fa-envelope"></i></a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h3 class="team-title">Mr. Rajkumar Balani</h3>
                    <!-- <span>Designer</span> -->
                  </div>
                </div>
                <!--  -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- OUR SERVICES -->
    <section class="our-services-sec mrg-top-70 pb-1 pt-5">
      <div class="container">
        <div class="area__subtitle">OUR SERVICES</div>
        <div class="row my-5">
          <!-- start-single-card -->
          <div class="col-lg-6 col-md-12 col-sm-12">
            <div
              class="our-services-card media border p-3 d-flex align-items-center"
            >
              <div class="service-icon rounded-full bg-blue-100">
                <svg
                  version="1.1"
                  width="50"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 480 480"
                  style="enable-background: new 0 0 480 480"
                  xml:space="preserve"
                  fill="#3289c7"
                >
                  <g>
                    <g>
                      <path
                        d="M408,288.64V88c0-48.601-39.399-88-88-88s-88,39.399-88,88v304c0,39.764-32.235,72-72,72c-39.764,0-72-32.236-72-72
			V191.36c27.517-3.992,47.947-27.555,48-55.36V48c0-4.418-3.582-8-8-8h-8V8c0-4.418-3.582-8-8-8H48c-4.418,0-8,3.582-8,8v32h-8
			c-4.418,0-8,3.582-8,8v88c0.053,27.805,20.483,51.367,48,55.36V392c0,48.601,39.399,88,88,88s88-39.399,88-88V88
			c0-39.765,32.236-72,72-72c39.765,0,72,32.235,72,72v200.64c-27.517,3.992-47.947,27.555-48,55.36v88c0,4.418,3.582,8,8,8h8v32
			c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8v-32h8c4.418,0,8-3.582,8-8v-88C455.947,316.195,435.517,292.633,408,288.64z M56,16
			h48v24H56V16z M40,136V56h80v80c0,22.091-17.909,40-40,40S40,158.091,40,136z M424,464h-48v-24h48V464z M440,424h-80v-80
			c0-22.091,17.909-40,40-40c22.091,0,40,17.909,40,40V424z"
                      />
                    </g>
                  </g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </div>
              <div class="media-body pl-4">
                <h3 class="py-3">Digital Cable</h3>
                <p>
                  Digital Cable enabled by STBs and Digital Headend offering
                  more than 181 channels in digital including 14 Radio Channels
                </p>
              </div>
            </div>
          </div>
          <!-- start-single-card -->
          <div class="col-lg-6 col-md-12 col-sm-12">
            <div
              class="our-services-card media border p-3 d-flex align-items-center"
            >
              <div class="service-icon rounded-full bg-blue-100">
                <svg
                  id="_x31__px"
                  enable-background="new 0 0 24 24"
                  viewBox="0 0 24 24"
                  width="50"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#3289c7"
                >
                  <path
                    d="m12 14c-.276 0-.5-.224-.5-.5v-8c0-.276.224-.5.5-.5s.5.224.5.5v8c0 .276-.224.5-.5.5z"
                  />
                  <path
                    d="m9.94 7.41c-.157 0-.313-.074-.409-.213-.347-.496-.531-1.083-.531-1.697s.184-1.201.531-1.697c.158-.228.47-.28.696-.123.226.158.281.47.122.696-.228.328-.349.716-.349 1.124s.121.796.35 1.124c.159.226.104.538-.122.696-.088.061-.188.09-.288.09z"
                  />
                  <path
                    d="m14.06 7.41c-.1 0-.199-.029-.287-.09-.226-.158-.281-.47-.122-.696.228-.328.349-.716.349-1.124s-.121-.796-.35-1.124c-.159-.226-.104-.538.122-.696.227-.157.539-.105.696.123.348.496.532 1.083.532 1.697s-.184 1.201-.531 1.697c-.097.139-.252.213-.409.213z"
                  />
                  <path
                    d="m7.46 9.11c-.159 0-.316-.076-.413-.218-.685-1.005-1.047-2.178-1.047-3.392s.362-2.387 1.047-3.392c.156-.229.47-.285.694-.131.229.155.287.466.132.695-.571.838-.873 1.816-.873 2.828s.302 1.99.873 2.828c.155.229.097.54-.132.695-.086.059-.183.087-.281.087z"
                  />
                  <path
                    d="m16.54 9.11c-.098 0-.195-.028-.281-.087-.229-.155-.287-.466-.132-.695.571-.838.873-1.816.873-2.828s-.302-1.99-.873-2.828c-.155-.229-.097-.54.132-.695.227-.153.539-.097.694.131.685 1.005 1.047 2.178 1.047 3.392s-.362 2.387-1.047 3.392c-.097.141-.254.218-.413.218z"
                  />
                  <path
                    d="m4.99 10.8c-.159 0-.315-.076-.412-.217-1.032-1.504-1.578-3.261-1.578-5.083s.546-3.579 1.578-5.083c.156-.228.468-.284.695-.129.228.156.285.467.129.695-.917 1.336-1.402 2.898-1.402 4.517s.485 3.181 1.402 4.517c.156.228.099.539-.129.695-.086.059-.185.088-.283.088z"
                  />
                  <path
                    d="m19.01 10.8c-.098 0-.196-.028-.283-.088-.228-.156-.285-.467-.129-.695.917-1.336 1.402-2.898 1.402-4.517s-.485-3.181-1.402-4.517c-.156-.228-.099-.539.129-.695.229-.155.54-.099.695.129 1.032 1.504 1.578 3.261 1.578 5.083s-.546 3.579-1.578 5.083c-.097.141-.253.217-.412.217z"
                  />
                  <path
                    d="m21.5 22h-19c-1.379 0-2.5-1.122-2.5-2.5v-4c0-1.378 1.121-2.5 2.5-2.5h19c1.379 0 2.5 1.122 2.5 2.5v4c0 1.378-1.121 2.5-2.5 2.5zm-19-8c-.827 0-1.5.673-1.5 1.5v4c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5v-4c0-.827-.673-1.5-1.5-1.5z"
                  />
                  <path
                    d="m3.5 24c-.276 0-.5-.224-.5-.5v-2c0-.276.224-.5.5-.5s.5.224.5.5v2c0 .276-.224.5-.5.5z"
                  />
                  <path
                    d="m20.5 24c-.276 0-.5-.224-.5-.5v-2c0-.276.224-.5.5-.5s.5.224.5.5v2c0 .276-.224.5-.5.5z"
                  />
                  <path
                    d="m19.5 19c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-2c-.275 0-.5.224-.5.5s.225.5.5.5.5-.224.5-.5-.225-.5-.5-.5z"
                  />
                  <path
                    d="m4.5 19c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-2c-.275 0-.5.224-.5.5s.225.5.5.5.5-.224.5-.5-.225-.5-.5-.5z"
                  />
                  <path
                    d="m9.5 19c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-2c-.275 0-.5.224-.5.5s.225.5.5.5.5-.224.5-.5-.225-.5-.5-.5z"
                  />
                </svg>
              </div>
              <div class="media-body pl-4">
                <h3 class="py-3">Internet & Broadband</h3>
                <p>
                  Broadband ISP and distributing Internet Service. Portfolio
                  includes Internet Access, Value Added Service - E-mail
                </p>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
      </div>
    </section>
    <!-- OUR APP -->
    <section class="our-app-sec mrg-top-70 pb-1">
      <div class="container">
        <div class="area__subtitle">About My Bripl App</div>
        <div class="row my-5">
          <!-- start-single-card -->
          <div class="col-lg-6 col-md-12 col-sm-12">
            <img src="../assets/images/bripl-mockup.png" width="70%;" />
          </div>
          <!-- start-single-card -->
          <div class="col-lg-6 col-md-12 col-sm-12">
            <p>
              BHIMA RIDDHI INFOTAINMENT PVT. LTD. (BRIPL), My Bripl, or my bripl
              which is a Android Mobile App for Enabling our customer to do
              top-up , Renewals and Activation of Channels and Packs.
            </p>
            <p>
              Please Register using your Set Top Box number or Smart Card
              number, get an OTP on Registered mobile number and proceed
            </p>
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="app-android">
                    <a class="arrow-button" href="https://play.google.com/store/apps/details?id=com.mybripl"
                      ><span class="button-icon"
                        ><img src="../assets/images/android.svg" /></span
                      ><span class="button-text"
                        ><span class="top_label">Download The App</span>Google
                        Play</span
                      ></a
                    >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
      </div>
    </section>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  data() {
    return {};
  },
  components: {
    Carousel,
    Slide,
  },
};
</script>
<style>
.VueCarousel-dot-container {
  margin-top: 20px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: rotate(90deg);
}
.home .area__subtitle {
  color: #fff;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 2px;
  background-color: transparent;
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#004dcc),
    to(#00baff)
  );
  background-image: linear-gradient(90deg, #004dcc 0%, #00baff 100%);
  border-radius: 50px 50px 50px 50px;
  margin: 0px 0px 20px 0px;
  padding: 10px 20px 10px 20px;
  display: inline-block;
}
.our-services-sec .service-icon {
  padding: 20px;
}
</style>
